import { ProjectScorecardPanel } from "apps/project-iq/components/ProjectScorecardPanel/ProjectScorecardPanel";
import { useStaticPageStyles } from "apps/project-iq/pages/staticPageStyles";
import { useQualityReviewPageStyles } from "./QualityReviewPage.styles";
import { IQualityReviewPageProps } from "./QualityReviewPage.types";
import { useQualityReviewAccess } from "./useQualityReviewAccess";

export const QualityReviewPage = ({
  workspaceId,
}: IQualityReviewPageProps): JSX.Element => {
  const styles = useQualityReviewPageStyles();
  const staticStyles = useStaticPageStyles();
  const hasAccess = useQualityReviewAccess(workspaceId);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        {hasAccess ? (
          <div className={styles.scorecardWrapper}>
            <ProjectScorecardPanel workspaceId={workspaceId} />
          </div>
        ) : (
          <div className={staticStyles.card}>
            Sorry, you don&apos;t have access to this page.
          </div>
        )}
      </div>
    </div>
  );
};
